import React, { MouseEventHandler } from "react";
import SearchFilterString from "../../model/SearchFilterString";

interface ISearchFilterCheckboxStringProps {
  name: string;
  onChange: (
    inputID: string,
    newValue: string | boolean | Set<number> | Set<string>
  ) => void;
  data: SearchFilterString[];
  selected: Set<string>;
}

/* Process filters based on string values */
function SearchFilterCheckboxString({
  name,
  onChange,
  data,
  selected,
}: ISearchFilterCheckboxStringProps) {
  const onFilterChange = (checked: boolean, id: string) => {
    if (checked) {
      selected.add(id);
    } else {
      selected.delete(id);
    }
    onChange(name, selected);
  };

  return (
    <div className="checkbox-filter">
      {data.map((item) => {
        return (
          <div key={name + "_" + item.id}>
            <input
              type="checkbox"
              id={name + "_" + item.id}
              name={name + "_" + item.id}
              checked={selected.has(item.id!)}
              onClick={(e) => onFilterChange(e.currentTarget.checked, item.id!)}
              onChange={() => {}}
            />
            <label>
              {item.name}

              {item.search_results_no && (
                <span>
                  (
                  <strong>
                    {item.search_results_no ?? item.search_results_no}
                  </strong>{" "}
                  results)
                </span>
              )}
            </label>
          </div>
        );
      })}
    </div>
  );
}

export default SearchFilterCheckboxString;
